module.exports = __webpack_public_path__ + "static/media/phoebe-bridgers-getty-grid-2.fc951c09.jpg";